import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { UcionicaService } from './ucionica-detalji.service';
import * as toastr from 'toastr';
import { Polaznik, Videozapis, Dokument, Predavac, Email, Uvjerenje, Ishodiucenja, Moduli, Prisutnost, Gantogram, Kriteriji } from './ucionica-detalji';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PolaznikPopis } from '../polaznici-popis/polaznici-popis';
import { VideoPopis } from '../videozapisi-popis/videozapisi-popis'
import { VideozapisiPopisService } from '../videozapisi-popis/videozapisi-popis.service'
import { DokumentPopis } from '../dokumenti-popis/dokument';
import { DokumentiPopisService } from '../dokumenti-popis/dokumenti-popis.service';
import { PredavacPopis } from '../predavaci-popis/predavaci-popis';
import { IshodiucenjaPopisService } from '../ishodiucenja-popis/ishodiucenja-popis.service';
import { AppConfig } from '../../../config';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ExcelService } from '../services/excel.service';

declare var moment: any;
import * as alertify from 'alertify.js';
declare var $: any;

declare var require: any
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
let pdfMake = require('pdfmake/build/pdfmake.js');
let pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import { BrowserJsonp } from '@angular/http/src/backends/browser_jsonp';
/*
import config from 'devextreme/core/config';

config({
  thousandsSeparator: '.',
  decimalSeparator: ','
}) 
*/

@Component({
  selector: 'app-ucionica-detalji',
  templateUrl: './ucionica-detalji.component.html',
  styleUrls: ['./ucionica-detalji.component.css'],
  providers: [UcionicaService, VideozapisiPopisService, DokumentiPopisService, IshodiucenjaPopisService]
})
export class UcionicaDetaljiComponent implements OnInit {

  sviPolaznici: Polaznik[] = [];
  sviPolazniciPopis: PolaznikPopis[] = [];
  dataTablesOptions: DataTables.Settings = {};
  polaznikTrigger: Subject<Polaznik> = new Subject();

  sviVideozapisi: Videozapis[] = [];
  sviVideozapisiPopis: VideoPopis[] = [];
  videozapisTrigger: Subject<Videozapis> = new Subject();

  sviVideozapisiPolaznik: any[];
  ukupanbrojvideozapisapolaznik: number = 0;

  sviEmailoviPolaznik: any[];
  ukupanbrojemailovapolaznik: number = 0;

  sviDokumenti: Dokument[] = [];
  sviDokumentiPopis: DokumentPopis[] = [];
  dokumentTrigger: Subject<Dokument> = new Subject();

  sviPredavaci: Predavac[] = [];
  sviPredavaciPopis: PredavacPopis[] = [];
  predavacTrigger: Subject<Predavac> = new Subject();

  sveEmailadrese: Email[] = [];
  emailTrigger: Subject<Email> = new Subject();
  emailadreseZaSlanje: any = [];

  svaUvjerenja: Uvjerenje[] = [];
  uvjerenjeTrigger: Subject<Uvjerenje> = new Subject();
  polazniciZaSlanje: any = [];
  uvjerenjazaispis:any = [];

  sviIshodiucenja: Ishodiucenja[] = [];
  ishodiucenjaTrigger: Subject<Ishodiucenja> = new Subject();

  sviModuli: Moduli[] = [];
  nastavnejediniceTrigger: Subject<Moduli> = new Subject();

  sviModuliUcionica: any = [];
  sviModuliUcionicaNastavnaJedinica: any = [];
  moduliTrigger: Subject<Moduli> = new Subject();

  svaPrisutnost: Prisutnost[] = [];
  prisutnostTrigger: Subject<Prisutnost> = new Subject();

  ishodiNastavneJedinice = []; /*Moduli[] = []; */
  ishodiNastavneJediniceTrigger: Subject<Moduli> = new Subject();
  imaIshoda: boolean = false;
  dodajIshodGumb: boolean = false;
  idPodrucjeZnanjaPrivremeno: number;
  idNastavnaJedinica: number;

  savRaspored: any = [];
  ukupanbrojrasporeda: number = 0;

  polaznikForma: FormGroup;
  sastanakForma: FormGroup;
  ocjeniForma: FormGroup;
  videozapisForma: FormGroup;
  videozapisEditForma: FormGroup;
  dokumentForma: FormGroup;
  dokumentEditForma: FormGroup;
  predavacForma: FormGroup;
  emailForma: FormGroup;
  uvjerenjeForma: FormGroup;
  ishodiucenjaForma: FormGroup;
  ishodiucenjaEditForma: FormGroup;
  modulForma: FormGroup;
  modulEditForma: FormGroup;
  dodani_modulEditForma: FormGroup;
  prisutnostForma: FormGroup;
  ishodNastavneJediniceAddForma: FormGroup;
  kriterijiProlaznostiForma: FormGroup;
  postojiKriterijProlaznosti: boolean = false;

  ucionicaId: string;
  idkorisnikucionica: string;
  idvideozapisucionica: string;
  iddokumentucionica: string;
  iducionicaishodiucenja: string;
  ucionicaishodiucenja: number;
  iducionicamodul: string;
  idmodulnew: string;
  idkorisniksastanak: string;
  idkorisnikvideozapis: string;

  tabNaziv: string = 'prikaziPolaznike';

  polaznici: any;

  naziv: string;
  ucionica_datumOd: any;
  ucionica_datumDo: any;

  accessToken: any = localStorage.getItem('tokenSql');
  URL: any = AppConfig.IPfile;
  PDFuvjerenja: any = '';
  iduvjerenje: any;

  oznaka: number = 0;
  oznakaUvjerenje: number = 0;
  svevrsteuvjerenja: any = [];
  svapodrucjaznanja: any = [];
  sviishodiucenja: any = [];
  sviaktivnimoduli: any = [];
  sviaktivnimodulipopis: any = [];
  sviaktivnimodulinewpopis: any = [];

  myDatePickerOptions = {
		todayBtnTxt: 'Danas',
		dateFormat: 'dd.mm.yyyy',
		firstDayOfWeek: 'mo',
		sunHighlight: true,
		height: '34px',
		width: '100%',
		inline: false,
		selectionTxtFontSize: '16px',
		dayLabels: {su: 'Ned', mo: 'Pon', tu: 'Uto', we: 'Sri', th: 'Čet', fr: 'Pet', sa: 'Sub'},
		monthLabels: { 1: 'Sij', 2: 'Velj', 3: 'Ožu', 4: 'Tra', 5: 'Svi', 6: 'Lip', 7: 'Srp', 8: 'Kol', 9: 'Ruj', 10: 'Lis', 11: 'Stu', 12: 'Pro' }
  };
  
  datumOd: any;
  datumDo: any;
  datumOd_provjera: any;
  datumDo_provjera: any;
  datumprovjera: number = 1;
  datum: any;
  satiod: Date;
  satido: Date;
  videozapisid: any;
  dokumentid: any;

  podatcizaexcel: any = [];
  polaznicilistaPDF: any;
  zaprint: any;
  tablicaprisutnostpolaznika: any;

  podaciGantogram: Gantogram[] = [];
  dataSource: any;
  pivotGridDataSource: PivotGridDataSource;
  podaciGantogramPolaznik: Gantogram[] = [];
  pivotGridDataSourcePolaznik: PivotGridDataSource;
  ukupanbrojgantogrampolaznik: number = 0;
  broj: any;

  prikaziGumbZaIspisUvjerenja: boolean = false;

  constructor(private _fb: FormBuilder,
              private _ucionicaService: UcionicaService,
              private _videozapisiPopisService: VideozapisiPopisService,
              private _dokumentiPopisService: DokumentiPopisService,
              private _ishodiucenjaPopisService: IshodiucenjaPopisService,
              public _router: Router,
              private _activated: ActivatedRoute,
              private _sanitizer: DomSanitizer,
              private _excelService: ExcelService) {

              if(this._activated.snapshot.params['id']){
                this.ucionicaId = this._activated.snapshot.params['id'];
                this.detalji(this.ucionicaId);
                this.popisPolaznika(this.ucionicaId);
                // this.popisVideozapis();
                // this.popisDokumenata();
                // this.popisPredavaca();
                // this.dohvatiEmailAdrese();
                // this.dohvatiUvjerenja();
                // this.dohvatiKompetencije();
                // this.dohvatiModule();
                // this.dohvatiDodaneModuleUcionica();
                // this.dohvatiSvaPodrucjaznanja();
                // this.dohvatiPodatkeGantogram();
                // this.dohvatiKriterije();
                // this.dohvatiIshodeNastavneJedinice();
              } else {
                alert('ID učionice nepoznat!')
              }
  }

  ngOnInit() {
    this.dohvatiPopisPolaznika();
    this.dohvatiPopisVideozapisa();
    this.dohvatiPopisDokumenata();
    this.dohvatiPopisPredavaca();
    this.dohvatiPopisKompetencija();
    this.dohvatiAktivneModuleUcionica();
    this.dohvatiAktivneModulePopis();
    this.dohvatiAktivneModuleNewPopis();
    //Tablica početak
    this.dataTablesOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.polaznikForma = this._fb.group({
      korisnikId: ['']
    });
    this.sastanakForma = this._fb.group({
      naziv: {value: '', disabled: true},
      datumivrijeme: [''],
      status: ['']
    });
    this.ocjeniForma = this._fb.group({
      polozio: ['']
    });
    this.videozapisForma = this._fb.group({
      videozapisId: [''],
      trajanjevideozapisa: [''],
      datumOd: [''],
      datumDo: [''],
      maxbrpregleda: [''],
      modul: ['']
    });
    this.videozapisEditForma = this._fb.group({
      naziv: [''],
      trajanjevideozapisa: [''],
      datumOd: [''],
      datumDo: [''],
      maxbrpregleda: [''],
      modul: ['']
    });
    this.dokumentForma = this._fb.group({
      dokumentId: [''],
      datumOd: [''],
      datumDo: [''],
      modul: ['']
    });
    this.dokumentEditForma = this._fb.group({
      naziv: [''],
      datumOd: [''],
      datumDo: [''],
      modul: ['']
    });
    this.predavacForma = this._fb.group({
      predavacId: ['']
    });
    this.emailForma = this._fb.group({
      naslov: [''],
      tekst: ['']
    });
    this.uvjerenjeForma = this._fb.group({
      vrstaUvjerenja: ['']
    });
    this.ishodiucenjaForma = this._fb.group({
      podrucjeZnanja: [''],
      nastavnaJedinica: [''],
      ishodUcenja: ['']
    });
    this.ishodiucenjaEditForma = this._fb.group({
      rednibroj: ['']
    });
    this.kriterijiProlaznostiForma = this._fb.group({
      idkriterijtestiranjakompetencija: [''],
      opis: ['']
    });
    this.modulForma = this._fb.group({
      modulnew: [''],
      modul: ['']
    });
    this.modulEditForma = this._fb.group({
      naziv: [{value: '', disabled: true}],
      kratica: [{value: '', disabled: true}],
      rednibroj: [''],
      brojmodula: [''],
      redoslijedizvodenja: [''],
      datum: [''],
      aktivan: [''],
      idnacinpredavanja: ['']
    });
    this.dodani_modulEditForma = this._fb.group({
      naziv: [{value: '', disabled: true}],
      rednibroj: [''],
    });
    this.prisutnostForma = this._fb.group({
      modul: ['']
    });
    this.ishodNastavneJediniceAddForma = this._fb.group({
      sadrzaj: [''],
      idNastavnaJedinica: ['']
    });
  }

  detalji(ucionicaId){
    this._ucionicaService.detaljiUcionice({'iducionica':ucionicaId}).subscribe(res => {
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
            this.naziv = res.data[0].uc_naziv;
            this.ucionica_datumOd = res.data[0].datumOD;
            this.ucionica_datumDo = res.data[0].datumDO; 
        }
      } else {
         toastr.error("Neuspješno dohvaćanje!");
      }
    })
  }

  prikaziTab(tabNaziv){
    this.datumprovjera = 1;
    this.datumOd_provjera = '';
    this.datumDo_provjera = '';
    this.tabNaziv = tabNaziv;
    switch(tabNaziv){
      case 'prikaziPolaznike':
        this.popisPolaznika(this.ucionicaId);
  
        this.savRaspored = [];
        this.ukupanbrojrasporeda = 0;
        
        this.sviVideozapisiPolaznik = [];
        this.ukupanbrojvideozapisapolaznik = 0;

        this.sviEmailoviPolaznik = [];
        this.ukupanbrojemailovapolaznik = 0;

        this.podaciGantogramPolaznik = [];
        this.ukupanbrojgantogrampolaznik = 0;
      break;
      case 'prikaziVideozapise':
        this.popisVideozapis();
        this.dohvatiAktivneModuleUcionica();
      break;
      case 'prikaziDokumente':
        this.popisDokumenata();
      break;
      case 'prikaziPredavace':
        this.popisPredavaca();
      break;
      case 'prikaziMailFormu':
        this.dohvatiEmailAdrese();
      break;
      case 'prikaziUvjerenja':
        this.dohvatiUvjerenja();
        this.dohvatiSveVrsteuvjerenja();
      break;
      case 'prikaziKompetencije':
        this.dohvatiKompetencije();
        this.dohvatiSvaPodrucjaznanja();
      break;
      case 'prikaziNastavneJedinice':
        this.dohvatiModule();
        this.dohvatiAktivneModulePopis();
        this.dohvatiAktivneModuleNewPopis();
      break;
      case 'prikaziModule':
        this.dohvatiDodaneModuleUcionica();
      break;
      case 'prisutnost':
        this.dohvatiAktivneModuleUcionica();
      break;
      case 'gantogram':
        this.dohvatiPodatkeGantogram();
        break;
      case 'prikaziKriterijeProlaznosti':
        this.dohvatiKriterije();
      break;
      case 'ishodiNastavneJedinice':
        this.dohvatiIshodeNastavneJedinice();
    }
  }

  // reInit() {
  //   $('#polazniciTablica').DataTable().destroy();
  //   this.popisPolaznika(this.ucionicaId);
  // }

  //POLAZNICI
  popisPolaznika(ucionicaId){
    $('#polazniciTablica').DataTable().destroy();
    this.sviPolaznici = [];
    this._ucionicaService.dohvatiPolaznike({'iducionica': ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviPolaznici.push({
            'idkorisnikucionica': res.data[i]['idkorisnikucionica'],
            'id': res.data[i]['korisnik_idkorisnik'],
            'imeprezime': res.data[i]['ko_imeiprezime'],
            'spol': res.data[i]['ko_spol'],
            'oib': res.data[i]['ko_oib'],
            'email': res.data[i]['ko_email'],
            'lozinka': res.data[i]['ko_lozinka'],
            'telefon': res.data[i]['ko_telefon'],
            'adresa': res.data[i]['ko_adresa'],
            'mjesto': res.data[i]['ko_grad'],
            'partnerId': res.data[i]['partner_idpartner'],
            'partnerNaziv': res.data[i]['pa_nazivtvrtke'],
            'aktivan': res.data[i]['ku_aktivan'],
            'polozio': res.data[i]['ku_polozio']
          });
        }
        // this.polaznikTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje popisa polaznika!");
      }
    })
  }

  //Autocomplete popis polaznika
  dohvatiPopisPolaznika(){
    this.sviPolazniciPopis = [];
    this._ucionicaService.dohvatiAktivnePolaznike({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
         this.sviPolazniciPopis.push({
          'id': res.data[i]['idkorisnik'],
          'imeprezime': res.data[i]['ko_imeiprezime'],
          'spol': res.data[i]['ko_spol'],
          'oib': res.data[i]['ko_oib'],
          'email': res.data[i]['ko_email'],
          'telefon': res.data[i]['ko_telefon'],
          'adresa': res.data[i]['ko_adresa'],
          'mjesto': res.data[i]['ko_grad'],
          'partnerId': res.data[i]['partner_idpartner'],
          'partnerNaziv': res.data[i]['pa_nazivtvrtke'],
          'aktivan': res.data[i]['ko_aktivan']
        });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  autocompleListFormatter = (data: any) : SafeHtml => {
    let html = `<span>${data.imeprezime}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  traziPolaznika(e){
    //console.log(e);
    this.polaznikForma.value.korisnikId = e.id;
  }

  dodajPolaznika(polaznikForma){
    //console.log(polaznikForma);
    let objektZaSlanje = {
      'polaznikid': polaznikForma['korisnikId'],
      'iducionica': this.ucionicaId
    };
    //console.log(objektZaSlanje);
    if(polaznikForma['korisnikId']){
      this._ucionicaService.addPolaznik_ucionica(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          //toastr.success("Uspješno dodan polaznik!");
          toastr.success(res.data[0][0].poruka);
          $('#polazniciTablica').DataTable().clear();
          $('#polazniciTablica').DataTable().destroy();
          this.popisPolaznika(this.ucionicaId);
          this.polaznikForma = this._fb.group({
            korisnikId: ['']
          });
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  aktivirajPolaznika(polaznik){
    //console.log(polaznik);
    if(polaznik.aktivan == 0){
      let ovo = this;
      alertify
      .okBtn("Aktiviraj")
      .cancelBtn("Odustani")
      .confirm("Jeste li sigurni da želite aktivirati polaznika?", function (ev) {
        ev.preventDefault();
        if (alertify.success){
          ovo._ucionicaService.aktivirajPolaznik_ucionica({'idkorisnikucionica': polaznik.idkorisnikucionica, 'polaznikid': polaznik.id, 'iducionica': ovo.ucionicaId, 'nazivedukacije': ovo.naziv}).subscribe(res => {
            //console.log(res);
            if(res.success == true){
              toastr.success("Polaznik uspješno aktiviran!");
              ovo.popisPolaznika(ovo.ucionicaId);
            } else {
              toastr.error(res.message);
            }
          })
        }
      }, function(ev) {
        ev.preventDefault();
        toastr.info('Odustali ste od aktiviranja polaznika.');
      });
    }else if(polaznik.aktivan == 1){
      let ovo = this;
      alertify
      .okBtn("Deaktiviraj")
      .cancelBtn("Odustani")
      .confirm("Jeste li sigurni da želite deaktivirati polaznika?", function (ev) {
        ev.preventDefault();
        if (alertify.success){
          ovo._ucionicaService.deaktivirajPolaznik_ucionica({'idkorisnikucionica': polaznik.idkorisnikucionica, 'polaznikid': polaznik.id, 'iducionica': ovo.ucionicaId}).subscribe(res => {
            //console.log(res);
            if(res.success == true){
              toastr.success("Polaznik uspješno deaktiviran!");
              ovo.popisPolaznika(ovo.ucionicaId);
            } else {
              toastr.error(res.message);
            }
          })
        }
      }, function(ev) {
        ev.preventDefault();
        toastr.info('Odustali ste od deaktiviranja polaznika.');
      });
    }
  }

  pripremiPodatkePolaznik(polaznik){
    //console.log(polaznik);
    this.idkorisnikucionica = polaznik['idkorisnikucionica'];
    this.ocjeniForma= this._fb.group({
      polozio: polaznik['polozio']
    })
  }

  ocjeniPolaznika(polaznik){
    //console.log(polaznik);
    let objektZaSlanje = {
      'idkorisnikucionica': this.idkorisnikucionica,
      'polozio': polaznik['polozio']
    };
    //console.log(objektZaSlanje);
    this._ucionicaService.ocjeniPolaznik_ucionica(objektZaSlanje).subscribe(res=>{
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.popisPolaznika(this.ucionicaId);
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    })
  }

  obrisiPolaznika(polaznik){
    //console.log(polaznik);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati polaznika?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.obrisiPolaznik_ucionica({'idkorisnikucionica': polaznik.idkorisnikucionica, 'polaznikid': polaznik.id, 'iducionica': ovo.ucionicaId}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Polaznik uspješno obrisan!");
            ovo.popisPolaznika(ovo.ucionicaId);
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja polaznika.');
    });
  }

  dohvatiSastankeZaPolaznika(polaznikID){
    // console.log(polaznikID);
    this.savRaspored = [];
    
    /* ponistava prikaz popisa videozapisa za polaznika */
    this.ukupanbrojvideozapisapolaznik = 0;
    /* ponistava prikaz arhiviranih emailova za polaznika */
    this.ukupanbrojemailovapolaznik = 0;
    /* ponistava prikaz osobni gantogram */
    this.ukupanbrojgantogrampolaznik = 0;

    this._ucionicaService.dohvatiSastanke({'idkorisnik': polaznikID, 'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        this.ukupanbrojrasporeda = res.data.length;
        if(this.ukupanbrojrasporeda == 0){
          toastr.error("Ne postoji podatak o ugovorenim sastancima");
        } else {
          for(let i = 0; i < res.data.length; i++){
            this.savRaspored.push({
              'id': res.data[i]['idsastanak'],
              'idUcionicamodul': res.data[i]['ucionicamodul_iducionicamodul'],
              'datumsastanka': res.data[i]['datumsastankaprikaz'],
              'vrijemesastanka': res.data[i]['vrijemesastankaprikaz'],
              'datumivrijemesastankasql': res.data[i]['sa_vrijemesastanka'],
              'idkorisnik': res.data[i]['korisnik_idkorisnik'],
              'naziv': res.data[i]['mo_naziv'],
              'status':  res.data[i]['sa_status']
            })
          }
        }
      }else{
        toastr.error("Neuspješno dohvaćanje modula!");
        this.ukupanbrojrasporeda = 0;
      }
    });
  }

  pripremiPodatkeSastanak(raspored){
    //console.log(raspored);
    this.iducionicamodul = raspored['idUcionicamodul'];
    this.idkorisniksastanak = raspored['idkorisnik'];
    this.sastanakForma = this._fb.group({
      naziv: raspored['naziv'],
      datumivrijeme: raspored['datumivrijemesastankasql'],
      status: raspored['status']
    });
  }

  dogovoriSastanak(sastanak){
    //console.log(sastanak);
    this._ucionicaService.urediSastanak({'idkorisnik': this.idkorisniksastanak, 'iducionica': this.ucionicaId, 'iducionicamodul': this.iducionicamodul, 'datumivrijeme': sastanak.datumivrijeme, 'status': sastanak.status}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.dohvatiSastankeZaPolaznika(this.idkorisniksastanak);
      }else{
        toastr.error("Neuspješno spremanje!");
      }
    });
  }

  dohvatiVideozapisePolaznik(polaznikid){
    //console.log('polaznikid: ', polaznikid);
    this.idkorisnikvideozapis = polaznikid;
    this.sviVideozapisiPolaznik = [];

    /* ponistava prikaz popisa sastanaka koji su za ugovoriti */
    this.ukupanbrojrasporeda = 0;
    /* ponistava prikaz arhiviranih emailova za polaznika */
    this.ukupanbrojemailovapolaznik = 0;
    /* ponistava prikaz osobni gantogram */
    this.ukupanbrojgantogrampolaznik = 0;

    this._ucionicaService.dohvatiVideozapisePolaznik({'idkorisnik': this.idkorisnikvideozapis, 'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        this.ukupanbrojvideozapisapolaznik = res.data.length;
        if(res.data.length > 0){
          for(let i = 0; i < res.data.length; i++){
            this.sviVideozapisiPolaznik.push({
              'id': res.data[i]['idvideomaterijal'],
              'idkorisnik': res.data[i]['korisnik_idkorisnik'],
              'rednibroj': res.data[i]['um_redoslijedizvodenja'],
              'naziv': res.data[i]['vz_videonaziv'],
              'link': res.data[i]['link'],
              'trenutno_gledanja': res.data[i]['bg_brojgledanja'] || 0,
              'max_gledanja': res.data[i]['vz_maxbrojpregleda'],
              'datum_od': moment(res.data[i]['vz_dostupnostOd']).format('DD.MM.YYYY.'),
              'datum_do': moment(res.data[i]['vz_dostupnostDo']).format('DD.MM.YYYY.'),
              'statuspregledavideozapisa': res.data[i]['statuspregledavideozapisa'],
              'statusvideozapisa': res.data[i]['statusvideozapisa'],
              'idvideozapisucionica': res.data[i]['idvideozapisucionica'],
              'kratica': res.data[i]['um_kratica'],
              'iducionicamodul': res.data[i]['iducionicamodul']
            });
          }
        } else {
          toastr.error("Nema videozapisa za ovu učionicu!");
        }
      } else {
        this.ukupanbrojvideozapisapolaznik = 0;
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  omoguciBrojPregleda(videozapis){
    //console.log(videozapis);
    this._ucionicaService.dodjeliPregledaPolazniku({'idkorisnik': videozapis.idkorisnik, 'iducionica': this.ucionicaId, 'idvideozapisucionica': videozapis.idvideozapisucionica}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno dodjeljen pregled!");
        //console.log('idkorisnikvideozapis: ',this.idkorisnikvideozapis);
        this.dohvatiVideozapisePolaznik(this.idkorisnikvideozapis);
      }
      else{
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  arhivaEmailPolaznik(polaznik){
    //console.log(polaznik);
    
    /* ponistava prikaz popisa sastanaka koji su za ugovoriti */
    this.ukupanbrojrasporeda = 0;
    /* ponistava prikaz popisa videozapisa za polaznika */
    this.ukupanbrojvideozapisapolaznik = 0;
    /* ponistava prikaz osobni gantogram */
    this.ukupanbrojgantogrampolaznik = 0;

    this.sviEmailoviPolaznik = [];
    this._ucionicaService.dohvatiEmailovePolaznik({'email': polaznik.email, 'iducionica': this.ucionicaId}).subscribe(res=>{
      //console.log(res);
      if(res.success == true){
        this.ukupanbrojemailovapolaznik = res.data.length;
        for(let i = 0; i < res.data.length; i++){
          this.sviEmailoviPolaznik.push({
            'datum': res.data[i]['datumprikaz'],
            'naslov': res.data[i]['po_naslov'],
            'tekst': res.data[i]['po_tekst']
          });
        }
      }else{
        this.ukupanbrojemailovapolaznik = 0;
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  dohvatiGantogramPolaznik(polaznik){
    //console.log(polaznik);

    /* ponistava prikaz popisa sastanaka koji su za ugovoriti */
    this.ukupanbrojrasporeda = 0;
    /* ponistava prikaz arhiviranih emailova za polaznika */
    this.ukupanbrojemailovapolaznik = 0;
    /* ponistava prikaz popisa videozapisa za polaznika */
    this.ukupanbrojvideozapisapolaznik = 0;

    this.podaciGantogramPolaznik = [];
    this._ucionicaService.gantogramPolaznik({'idkorisnik': polaznik.id, 'iducionica': this.ucionicaId}).subscribe(res=>{
      //console.log(res);
      if(res.success == true){
        let prisutan;
        this.ukupanbrojgantogrampolaznik = res.data.length;
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['um_datum']){
            if(res.data[i]['kum_prisutan'] == 1){
              prisutan = 'DA';
            }else{
              prisutan = null;
            }
            this.podaciGantogramPolaznik.push({
              'id': res.data[i]['idkorisnikucionicamodul'],
              'imeiprezime': res.data[i]['ko_imeiprezime'],
              'modul': res.data[i]['um_kratica'],
              'modulgantogram': res.data[i]['kraticagantogram'],
              'prisutan': prisutan,
              'datum': moment(res.data[i]['um_datum']).format('DD.MM.YYYY.')
            })
          }else{
            if(res.data[i]['kum_prisutan'] == 1){
              prisutan = 'DA';
            }else{
              prisutan = null;
            }
            this.podaciGantogramPolaznik.push({
              'id': res.data[i]['idkorisnikucionicamodul'],
              'imeiprezime': res.data[i]['ko_imeiprezime'],
              'modul': res.data[i]['um_kratica'],
              'modulgantogram': res.data[i]['kraticagantogram'],
              'prisutan': prisutan,
              'datum': null
            })
          }
        }  
        
        this.pivotGridDataSourcePolaznik = new PivotGridDataSource({
          fields: [{  
            caption: 'Modul',
            dataField: 'modulgantogram',
            dataType: 'string',
            expanded: true,
            area: 'column',
          },
          {
            caption: 'Datum', 
            dataField: 'datum',
            dataType: 'string',        
            area: 'column'
          },
          {
            caption: 'Ime i prezime',
            width: 150,
            dataField: 'imeiprezime',
            area: 'row'
          },
          {
            caption: 'Prisutan',
            dataField: 'prisutan',
            dataType: 'string',
            area: 'data'     
          },        
        ],
          store: this.podaciGantogramPolaznik  
        }); 
        
      }else{
        this.ukupanbrojgantogrampolaznik = 0;
      }
    });
  }



  //VIDEOZAPISI
  popisVideozapis(){
    this.sviVideozapisi = [];
    this._ucionicaService.dohvatiVideozapise({'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['vz_dostupnostOd'] && res.data[i]['vz_dostupnostDo']){
            this.sviVideozapisi.push({
              'idVideoZapis': res.data[i]['idvideozapisucionica'],
              'naziv': res.data[i]['vz_videonaziv'],
              'trajanjevideozapisa': res.data[i]['vz_vrijemetrajanjavideozapisa'],
              'sifra': res.data[i]['vm_sifra'],
              'datumOd': moment(res.data[i]['vz_dostupnostOd']).format('DD.MM.YYYY.'),
              'datumDo': moment(res.data[i]['vz_dostupnostDo']).format('DD.MM.YYYY.'),
              'maxbrpregleda': res.data[i]['vz_maxbrojpregleda'],
              'modul': res.data[i]['modul_idmodul'],
              'kratica': res.data[i]['um_kratica']
            });
          }else{
            this.sviVideozapisi.push({
              'idVideoZapis': res.data[i]['idvideozapisucionica'],
              'naziv': res.data[i]['vz_videonaziv'],
              'trajanjevideozapisa': res.data[i]['vz_vrijemetrajanjavideozapisa'],
              'sifra': res.data[i]['vm_sifra'],
              'datumOd': null,
              'datumDo': null,
              'maxbrpregleda': res.data[i]['vz_maxbrojpregleda'],
              'modul': res.data[i]['modul_idmodul'],
              'kratica': res.data[i]['um_kratica']
            });
          }
        }
        this.videozapisTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  //Autocomplete popis videozapisa
  dohvatiPopisVideozapisa(){
    this.sviVideozapisiPopis = [];
    this._videozapisiPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviVideozapisiPopis.push({
            'id': res.data[i]['idvideomaterijal'],
            'naziv': res.data[i]['vm_naziv'],
            'link': res.data[i]['vm_sifra']
          });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  autocompleListFormatterVideo = (data: any) : SafeHtml => {
    let html = `<span>${data.naziv}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  traziVideozapis(e){
    //console.log(e);
    /* this.videozapisForma.value.videozapisId = e.id; */
    this.videozapisid = e.id;
  }

  dodajVideozapis(videozapisForma){
    //console.log(videozapisForma);
    let objektZaSlanje = {
      'idvideomaterijal': this.videozapisid,
      'iducionica': this.ucionicaId,
      'trajanjevideozapisa': videozapisForma.trajanjevideozapisa,
      'datumOd': moment(videozapisForma.datumOd.jsdate).format('YYYY-MM-DD'),
      'datumDo': moment(videozapisForma.datumDo.jsdate).format('YYYY-MM-DD'),
      'maxbrpregleda': videozapisForma.maxbrpregleda,
      'idmodul': videozapisForma.modul
    };
    //console.log(objektZaSlanje);
    if(this.videozapisid){
      this._ucionicaService.addVideozapis_ucionica(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno dodan videozapis!");
          $('#videozapisiTablica').DataTable().clear();
          $('#videozapisiTablica').DataTable().destroy();
          this.popisVideozapis();
          this.videozapisForma = this._fb.group({
            videozapisId: [''],
            trajanjevideozapisa: [''],
            datumOd: [''],
            datumDo: [''],
            maxbrpregleda: [''],
            modul: ['']
          });
          this.videozapisid = '';
          this.datumOd_provjera = '';
          this.datumDo_provjera = '';
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  pripremiPodatkeVideozapis(video){
    //console.log(video);
    this.idvideozapisucionica = video['idVideoZapis'];
    this.videozapisEditForma = this._fb.group({
      naziv: video['naziv'],
      trajanjevideozapisa: video['trajanjevideozapisa'],
      datumOd: video['datumOd'],
      datumDo: video['datumDo'],
      maxbrpregleda: video['maxbrpregleda'],
      modul: video['modul']
    });
    this.datumOd = video['datumOd'];
    this.datumDo = video['datumDo'];
  }

  urediVideozapis(video){
    //console.log(video);
    let datum1; 
    let datum2;
    if(video.value.datumOd.jsdate){
      datum1 = moment(video.value.datumOd.jsdate).format('YYYY-MM-DD');
    } else {
      datum1 = moment(video.value.datumOd,'DD.MM.YYYY.').format('YYYY-MM-DD');
    }
    if(video.value.datumDo.jsdate){
      datum2 = moment(video.value.datumDo.jsdate).format('YYYY-MM-DD');
    } else {
      datum2 = moment(video.value.datumDo,'DD.MM.YYYY.').format('YYYY-MM-DD');
    }

    let podaciZaSlanje = {
      'idvideozapisucionica': this.idvideozapisucionica,
      'naziv': video.value.naziv,
      'trajanjevideozapisa': video.value.trajanjevideozapisa,
      'access_token': localStorage.getItem('tokenSql'),
      'datumOd': datum1,
      'datumDo': datum2,
      'maxbrpregleda': video.value.maxbrpregleda,
      'idmodul': video.value.modul
    }
    //console.log(podaciZaSlanje);
    this._ucionicaService.urediVideozapis_ucionica(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.popisVideozapis();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  obrisiVideozapis(videozapis){
    //console.log(videozapis);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati videozapis?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.obrisiVideozapis_ucionica({'idvideozapisucionica': videozapis.idVideoZapis, 'iducionica': ovo.ucionicaId}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Videozapis uspješno obrisan!");
            ovo.popisVideozapis();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja videozapisa.');
    });
  }

  provjeriDatumOd(event:any){
    //console.log(event);
    this.datumOd_provjera = moment(event.jsdate).format('YYYY-MM-DD');
    //console.log('datumOd_provjera: ', this.datumOd_provjera);
    if(this.datumDo_provjera){
      if(this.datumOd_provjera != 'Invalid date'){
        if(this.datumOd_provjera <= this.datumDo_provjera) {
          //console.log('datumOd je manji od datumDo ...uredu je...');
        }else{
          this.datumprovjera = 0;
          setTimeout(() => {
            this.datumprovjera = 1;
          }, 4000);
        }
      }
    }
  }

  provjeriDatumDo(event:any){
    //console.log(event);
    this.datumDo_provjera = moment(event.jsdate).format('YYYY-MM-DD');
    //console.log('datumDo_provjera: ', this.datumDo_provjera);
    if(this.datumOd_provjera){
      if(this.datumOd_provjera != 'Invalid date'){
        if(this.datumOd_provjera > this.datumDo_provjera){
          this.datumprovjera = 0;
          setTimeout(() => {
            this.datumprovjera = 1;
          }, 4000);
        }else{
          //console.log('datumOd je manji od datumDo ..uredu je..');
        }
      }
    }
  }
  


  //DOKUMENTI
  popisDokumenata(){
    this.sviDokumenti = [];
    this._ucionicaService.dohvatiDokumente({'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['ud_dostupnostOd'] && res.data[i]['ud_dostupnostDo']){
            this.sviDokumenti.push({
              'idDokumentucionica': res.data[i]['iducionicadokument'],
              'naziv': res.data[i]['ud_pisaninaziv'],
              'datumOd': moment(res.data[i]['ud_dostupnostOd']).format('DD.MM.YYYY.'),
              'datumDo': moment(res.data[i]['ud_dostupnostDo']).format('DD.MM.YYYY.'),
              'datum': moment(res.data[i]['ud_vrijemeuplouda']).format('DD.MM.YYYY.'),
              'ud_nazivtablice': res.data[i]['ud_nazivtablice'],
              'ud_nazivdokumenta': res.data[i]['ud_nazivdokumenta'],
              'modul': res.data[i]['modul_idmodul'],
              'kratica': res.data[i]['um_kratica']
            });
          }else{
            this.sviDokumenti.push({
              'idDokumentucionica': res.data[i]['iducionicadokument'],
              'naziv': res.data[i]['ud_pisaninaziv'],
              'datumOd': null,
              'datumDo': null,
              'datum': moment(res.data[i]['ud_vrijemeuplouda']).format('DD.MM.YYYY.'),
              'ud_nazivtablice': res.data[i]['ud_nazivtablice'],
              'ud_nazivdokumenta': res.data[i]['ud_nazivdokumenta'],
              'modul': res.data[i]['modul_idmodul'],
              'kratica': res.data[i]['um_kratica']
            });
          }
        }
        this.dokumentTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  //Autocomplete popis dokumenata
  dohvatiPopisDokumenata(){
    this.sviDokumentiPopis = [];
    this._dokumentiPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviDokumentiPopis.push({
            'id': res.data[i]['iduploaddokument'],
            'naziv': res.data[i]['ud_naziv'],
            'dokument': res.data[i]['ud_nazivdokumenta_orig'],
            'datum': moment(res.data[i]['ud_vrijemeuplouda']).format('DD.MM.YYYY.'),
            'ud_nazivtablice': res.data[i]['ud_nazivtablice'],
            'ud_nazivdokumenta': res.data[i]['ud_nazivdokumenta']
          });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }
  
  autocompleListFormatterDokument = (data: any) : SafeHtml => {
    let html = `<span>${data.naziv}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
  
  traziDokument(e){
    //console.log(e);
    //this.dokumentForma.value.dokumentId = e.id;
    this.dokumentid = e.id;
  }

  dodajDokument(dokumentForma){
    //console.log(dokumentForma);
    let objektZaSlanje = {
      'iduploaddokument': this.dokumentid,
      'iducionica': this.ucionicaId,
      'datumOd': moment(dokumentForma.datumOd.jsdate).format('YYYY-MM-DD'),
      'datumDo': moment(dokumentForma.datumDo.jsdate).format('YYYY-MM-DD'),
      'idmodul': dokumentForma.modul
    };
    //console.log(objektZaSlanje);
    if(this.dokumentid){
      this._ucionicaService.addDokument_ucionica(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno dodan dokument!");
          $('#dokumentiTablica').DataTable().clear();
          $('#dokumentiTablica').DataTable().destroy();
          this.popisDokumenata();
          this.dokumentForma = this._fb.group({
            dokumentId: [''],
            datumOd: [''],
            datumDo: [''],
            modul: ['']
          });
          this.dokumentid = '';
          this.datumOd_provjera = '';
          this.datumDo_provjera = '';
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  pripremiPodatkeDokument(dokument){
    //console.log(dokument);
    this.iddokumentucionica = dokument['idDokumentucionica'];
    this.dokumentEditForma = this._fb.group({
      naziv: dokument['naziv'],
      datumOd: dokument['datumOd'],
      datumDo: dokument['datumDo'],
      modul: dokument['modul']
    });
    this.datumOd = dokument['datumOd'];
    this.datumDo = dokument['datumDo'];
  }

  urediDokument(dokument){
    //console.log(dokument);
    let datum1;
    let datum2;
    if(dokument.value.datumOd.jsdate){
      datum1 = moment(dokument.value.datumOd.jsdate).format('YYYY-MM-DD');
    } else {
      datum1 = moment(dokument.value.datumOd,'DD.MM.YYYY.').format('YYYY-MM-DD');
    }
    if(dokument.value.datumDo.jsdate){
      datum2 = moment(dokument.value.datumDo.jsdate).format('YYYY-MM-DD');
    } else {
      datum2 = moment(dokument.value.datumDo,'DD.MM.YYYY.').format('YYYY-MM-DD');
    }

    let podaciZaSlanje = {
      'iducionicadokument': this.iddokumentucionica,
      'naziv': dokument.value.naziv,
      'access_token': localStorage.getItem('tokenSql'),
      'datumOd': datum1,
      'datumDo': datum2,
      'idmodul': dokument.value.modul
    }
    //console.log(podaciZaSlanje);
    this._ucionicaService.urediDokument_ucionica(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.popisDokumenata();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  obrisiDokument(dokument){
    //console.log(dokument);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati pisani materijal?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.obrisiDokument_ucionica({'iducionicadokument': dokument.idDokumentucionica, 'iducionica': ovo.ucionicaId}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Pisani materijal uspješno obrisan!");
            ovo.popisDokumenata();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja pisanog materijala.');
    });
  }



  //PREDAVACI
  popisPredavaca(){
    this.sviPredavaci = [];
    this._ucionicaService.dohvatiPredavace({'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviPredavaci.push({
            'idPredavacucionica': res.data[i]['idkorisnikucionica'],
            'id': res.data[i]['idkorisnik'],
            'imeprezime': res.data[i]['ko_imeiprezime'],
            'email': res.data[i]['ko_email'],
            'telefon': res.data[i]['ko_telefon'],
            'aktivan': res.data[i]['ko_aktivan']
          });
          this.predavacTrigger.next();
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  //Autocomplete popis predavaca
  dohvatiPopisPredavaca(){
    this.sviPredavaciPopis = [];
    this._ucionicaService.dohvatiAktivnePredavace({'idkorisnik': localStorage.getItem('userId'), 'admin': localStorage.getItem('vrsta')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviPredavaciPopis.push({
            'id': res.data[i]['idkorisnik'],
            'imeprezime': res.data[i]['ko_imeiprezime'],
            'spol': res.data[i]['ko_spol'],
            'oib': res.data[i]['ko_oib'],
            'email': res.data[i]['ko_email'],
            'telefon': res.data[i]['ko_telefon'],
            'adresa': res.data[i]['ko_adresa'],
            'mjesto': res.data[i]['ko_grad'],
            'partnerId': res.data[i]['partner_idpartner'],
            'partnerNaziv': res.data[i]['pa_nazivtvrtke'],
            'aktivan': res.data[i]['ko_aktivan'],
            'opis': res.data[i]['ko_opis'],
          });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  autocompleListFormatterPredavac = (data: any) : SafeHtml => {
    let html = `<span>${data.imeprezime}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  traziPredavaca(e){
    //console.log(e);
    //console.log('id: ', e.id);
    this.predavacForma.value.predavacId = e.id;
  }

  dodajPredavaca(predavacForma){
    //console.log(predavacForma);
    let objektZaSlanje = {
      'predavacid': predavacForma['predavacId'],
      'iducionica': this.ucionicaId
    };
    //console.log(objektZaSlanje);
    if(predavacForma['predavacId']){
      this._ucionicaService.addPredavac_ucionica(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          //toastr.success("Uspješno dodan predavač!");
          toastr.success(res.data[0][0].poruka);
          $('#predavaciTablica').DataTable().clear();
          $('#predavaciTablica').DataTable().destroy();
          this.popisPredavaca();
          this.predavacForma = this._fb.group({
            predavacId: ['']
          });
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  obrisiPredavaca(predavac){
    //console.log(predavac);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati predavača?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.obrisiPredavac_ucionica({'idkorisnikucionica': predavac.idPredavacucionica, 'iducionica': ovo.ucionicaId}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Predavač uspješno obrisan!");
            ovo.popisPredavaca();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja predavača.');
    });
  }



  //EMAIL
  dohvatiEmailAdrese(){
    this.sveEmailadrese = [];
    if(this.oznaka == 0){
      this.oznaka = 0;
    }else{
      this.oznaka = 1;
    }
    this._ucionicaService.dohvatiPolaznike({'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sveEmailadrese.push({
            'imeprezime': res.data[i]['ko_imeiprezime'],
            'email': res.data[i]['ko_email'],
            'oznaka': this.oznaka
          })
        }
        this.emailTrigger.next();
      }else{
        toastr.error("Neuspješno dohvaćanje E-mail adresa!");
      }
    });
  }

  oznaciEmail(e, item){
    //console.log(e.target.checked);
    //console.log(item);
    if(e.target.checked == true){
      //console.log('dodajem email');
      this.emailadreseZaSlanje.push({
        'emailadresa': item.email
      })
      //console.log(this.emailadreseZaSlanje);
    }else if(e.target.checked == false){
      //console.log('uklanjam email');
      for(let i = 0; i < this.emailadreseZaSlanje.length; i++){
        if(this.emailadreseZaSlanje[i].emailadresa == item.email){
          //console.log('jednaki');
          this.emailadreseZaSlanje.splice(i, 1);
        }
      }
      if(this.emailadreseZaSlanje.length == 0){
        this.oznaka = 0;
      }
      //console.log(this.emailadreseZaSlanje);
    }
  }

  oznaciSve(e){
    //console.log(e.target.checked);
    $('#emailTablica').DataTable().clear();
    $('#emailTablica').DataTable().destroy();
    if(e.target.checked == true){
      this.oznaka = 1;
      this.emailadreseZaSlanje = [];
      for (let i = 0; i < this.sviPolaznici.length; i++) {
        this.emailadreseZaSlanje.push({
          'emailadresa': this.sviPolaznici[i]['email']
        })
      }
      //console.log(this.emailadreseZaSlanje);
      this.dohvatiEmailAdrese();
    }else if(e.target.checked == false){
      this.oznaka = 0;
      this.emailadreseZaSlanje = [];
      //console.log(this.emailadreseZaSlanje);
      this.dohvatiEmailAdrese();
    }
  }

  posaljiEmail(emailForma){
    //console.log(emailForma);
    let podaciZaSlanje = {
      'naslov': emailForma['naslov'],
      'tekst': emailForma['tekst'],
      'iducionica': this.ucionicaId,
      'emailadresa': this.emailadreseZaSlanje
    }
    //console.log(podaciZaSlanje);
    if(emailForma['naslov'] && emailForma['tekst'] && this.emailadreseZaSlanje.length != 0){
      this._ucionicaService.posalji_email(podaciZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno poslano!");
        } else {
          toastr.error("Neuspješno slanje!");
        }

      });
    }else{
      toastr.error("Unesite potrebne podatke!");
    }
  }



  //UVJERENJA
  dohvatiSveVrsteuvjerenja(){
    this._ucionicaService.dohvatiVrsteuvjerenja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      // console.log(res);
      if (res.success == true) {
        this.svevrsteuvjerenja = res.data;
      } else {
        this.svevrsteuvjerenja = [];
      }
    })
  }

  dohvatiUvjerenja(){
    this.svaUvjerenja = [];
    this._ucionicaService.dohvatiUvjerenja({'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        if (this.oznakaUvjerenje == 1) {
          for(let i = 0; i < res.data.length; i++){
            if (res.data[i]['ku_aktivan'] == 1) {
              this.svaUvjerenja.push({
                'idkorisnik': res.data[i]['korisnik_idkorisnik'],
                'imeprezime': res.data[i]['ko_imeiprezime'],
                'email': res.data[i]['ko_email'],
                'spol': res.data[i]['ko_spol'],
                'aktivan': res.data[i]['ku_aktivan'],
                'uvjerenja': res.data[i]['uvjerenja'],
                'oznaka': 1,
                'url': res.data[i]['ku_url']
              })
            }else if (res.data[i]['ku_aktivan'] == 0) {
              this.svaUvjerenja.push({
                'idkorisnik': res.data[i]['korisnik_idkorisnik'],
                'imeprezime': res.data[i]['ko_imeiprezime'],
                'email': res.data[i]['ko_email'],
                'spol': res.data[i]['ko_spol'],
                'aktivan': res.data[i]['ku_aktivan'],
                'uvjerenja': res.data[i]['uvjerenja'],
                'oznaka': 0,
                'url': res.data[i]['ku_url']
              })
            }
          }
        } else if (this.oznakaUvjerenje == 0) {
          for(let i = 0; i < res.data.length; i++){
            this.svaUvjerenja.push({
              'idkorisnik': res.data[i]['korisnik_idkorisnik'],
              'imeprezime': res.data[i]['ko_imeiprezime'],
              'email': res.data[i]['ko_email'],
              'spol': res.data[i]['ko_spol'],
              'aktivan': res.data[i]['ku_aktivan'],
              'uvjerenja': res.data[i]['uvjerenja'],
              'oznaka': 0,
              'url': res.data[i]['ku_url']
            })
          } 
        }
        this.uvjerenjeTrigger.next();
      }else{
        toastr.error("Neuspješno dohvaćanje uvjerenja!");
      }
    });
  }

  oznaciUvjerenje(e, item){
    //console.log(e.target.checked);
    //console.log(item);
    if(e.target.checked == true){
      //console.log('dodajem polaznika');
      this.polazniciZaSlanje.push({
        'idkorisnik': item.idkorisnik,
        'imeprezime': item.imeprezime,
        'spol': item.spol
      })
      //console.log(this.polazniciZaSlanje);

      this.uvjerenjazaispis.push({
        'idkorisnik': item.idkorisnik
      })
      //console.log(this.uvjerenjazaispis);
    }else if(e.target.checked == false){
      //console.log('uklanjam polaznika');
      for(let i = 0; i < this.polazniciZaSlanje.length; i++){
        if(this.polazniciZaSlanje[i].idkorisnik == item.idkorisnik){
          //console.log('jednaki');
          this.polazniciZaSlanje.splice(i, 1);
        }
      }
      if(this.polazniciZaSlanje.length == 0){
        this.oznakaUvjerenje = 0;
      }
      //console.log(this.polazniciZaSlanje);

      for(let i = 0; i < this.uvjerenjazaispis.length; i++){
        if(this.uvjerenjazaispis[i].idkorisnik == item.idkorisnik){
          //console.log('jednaki');
          this.uvjerenjazaispis.splice(i, 1);
        }
      }
    }
    //console.log(this.uvjerenjazaispis);
    this.PDFuvjerenja = JSON.stringify(this.uvjerenjazaispis);
	  //console.log(this.PDFuvjerenja);
  }

  oznaciSvaUvjerenja(e){
    //console.log(e.target.checked);
    $('#uvjerenjeTablica').DataTable().clear();
    $('#uvjerenjeTablica').DataTable().destroy();
    if (e.target.checked == true) {
      this.oznakaUvjerenje = 1;
      this.polazniciZaSlanje = [];
      for (let i = 0; i < this.svaUvjerenja.length; i++) {
        if (this.svaUvjerenja[i]['aktivan'] == 1) {
          this.polazniciZaSlanje.push({
            'idkorisnik': this.svaUvjerenja[i]['idkorisnik'],
            'imeprezime': this.svaUvjerenja[i]['imeprezime'],
            'spol': this.svaUvjerenja[i]['spol']
          });

          this.uvjerenjazaispis.push({
            'idkorisnik': this.svaUvjerenja[i]['idkorisnik']
          });
        }
      }
      //console.log(this.polazniciZaSlanje);
      //console.log(this.uvjerenjazaispis);
      this.dohvatiUvjerenja();
    } else if (e.target.checked == false) {
      this.oznakaUvjerenje = 0;
      this.polazniciZaSlanje = [];
      //console.log(this.polazniciZaSlanje);
      this.uvjerenjazaispis = [];
      //console.log(this.uvjerenjazaispis);
      this.dohvatiUvjerenja();
    }
    //console.log(this.uvjerenjazaispis);
    this.PDFuvjerenja = JSON.stringify(this.uvjerenjazaispis);
	  //console.log(this.PDFuvjerenja);
  }

  kreirajUvjerenja(uvjerenjeForma){
    this.prikaziGumbZaIspisUvjerenja = false;
    //console.log(uvjerenjeForma);
    let podaciZaSlanje = {
      'idvrstauvjerenja': uvjerenjeForma.vrstaUvjerenja,
      'nazivtablice': 'uvjerenja',
      'polozio': 1,
      'iducionica': this.ucionicaId,
      'polaznici': this.polazniciZaSlanje
    }
    //console.log(podaciZaSlanje);
    this._ucionicaService.kreirajUvjerenja(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      if(res.success == true){
        toastr.success("Uvjerenja uspješno kreirana!");
        // this.polazniciZaSlanje = [];
        this.dohvatiUvjerenja();
        this.prikaziGumbZaIspisUvjerenja = true;
      }else{
        toastr.error("Neuspješno kreiranje uvjerenja!");
      }
    });
  }


 
  //KOMPETENCIJE
  dohvatiSvaPodrucjaznanja(){
    this._ishodiucenjaPopisService.dohvatiAktivnaPodrucjaznanja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      // console.log(res);
      if (res.success == true) {
        this.svapodrucjaznanja = res.data[0];
      } else {
        this.svapodrucjaznanja = [];
      }
    })
  }

  dohvatiPopisKompetencija(){
    this.sviishodiucenja = [];
    this._ishodiucenjaPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviishodiucenja.push({
            'id': res.data[i]['idishodiucenja'],
            'naziv': res.data[i]['iu_tekst'],
            'idvrstauvjerenja': res.data[i]['vrstauvjerenja_idvrstauvjerenja'],
            'vrstauvjerenja': res.data[i]['vrstauvjerenjanaziv'],
            'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
            'podrucjeznanja': res.data[i]['podrucjeznanjanaziv']
          });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  dohvatiKompetencije(){
    this.sviIshodiucenja = [];
    this._ucionicaService.dohvatiKompetencije({'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviIshodiucenja.push({
            'idUcionicaishodiucenja': res.data[i]['ucionicaishodiucenja'],
            'rednibroj': res.data[i]['uiu_rednibroj'],
            'naziv': res.data[i]['iu_tekst'],
            'idvrstauvjerenja': res.data[i]['vrstauvjerenja_idvrstauvjerenja'],
            'vrstauvjerenja': res.data[i]['vrstauvjerenjanaziv'],
            'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
            'podrucjeznanja': res.data[i]['podrucjeznanjanaziv']
          })
        }
        this.ishodiucenjaTrigger.next();
      }else{
        toastr.error("Neuspješno dohvaćanje kompetencija!");
      }
    });
  }

  dodajsveKompetencije(ishodiucenjaForma){
    //console.log(ishodiucenjaForma);
    let objektZaSlanje = {
      'idpodrucjeznanja': ishodiucenjaForma['podrucjeZnanja'],
      'iducionica': this.ucionicaId
    };
    //console.log(objektZaSlanje);
    if(ishodiucenjaForma['podrucjeZnanja']){
      this._ucionicaService.addsveKompetencije_ucionica(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno dodane kompetencije!");
          $('#ishodiucenjaTablica').DataTable().clear();
          $('#ishodiucenjaTablica').DataTable().destroy();
          this.dohvatiKompetencije();
          this.ishodiucenjaForma = this._fb.group({
            podrucjeZnanja: [''],
            ishodUcenja: ['']
          });
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dodajjednuKompetenciju(ishodiucenjaForma){
    //console.log(ishodiucenjaForma);
    let objektZaSlanje = {
      'idishodiucenja': ishodiucenjaForma['ishodUcenja'],
      'iducionica': this.ucionicaId
    };
    //console.log(objektZaSlanje);
    if(ishodiucenjaForma['ishodUcenja']){
      this._ucionicaService.addjednaKompetencija_ucionica(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          //toastr.success("Uspješno dodana kompetencija!");
          toastr.success(res.data[0][0].poruka);
          $('#ishodiucenjaTablica').DataTable().clear();
          $('#ishodiucenjaTablica').DataTable().destroy();
          this.dohvatiKompetencije();
          this.ishodiucenjaForma = this._fb.group({
            podrucjeZnanja: [''],
            ishodUcenja: ['']
          });
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  pripremiPodatkeIshoducenja(ishod){
    //console.log(ishod);
    this.iducionicaishodiucenja = ishod['idUcionicaishodiucenja'];
    this.ishodiucenjaEditForma= this._fb.group({
      rednibroj: ishod['rednibroj']
    })
  }

  urediKompetenciju(ishod){
    //console.log(ishod);
    let podaciZaSlanje = {
      'ucionicaishodiucenja': this.iducionicaishodiucenja,
      'rednibroj': ishod['rednibroj']
    }
    //console.log(podaciZaSlanje);
    this._ucionicaService.urediKompetencija_ucionica(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.dohvatiKompetencije();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  obrisiIshoducenja(ishod){
    //console.log(ishod);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati kompetenciju?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.obrisiKompetencija_ucionica({'ucionicaishodiucenja': ishod.idUcionicaishodiucenja, 'iducionica': ovo.ucionicaId}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Uspješno obrisana kompetencija!");
            ovo.dohvatiKompetencije();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja kompetencije.');
    });
  }



  //MODULI
  dohvatiModule(){
    // $('#nastavnejediniceTablica').DataTable().clear();
    // $('#nastavnejediniceTablica').DataTable().destroy();
    this.sviModuli = [];
    this._ucionicaService.dohvatiModule({'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['um_datum']){
            this.sviModuli.push({
              'idUcionicamodul': res.data[i]['iducionicamodul'],
              'id': res.data[i]['idmodul'],
              'rednibroj': res.data[i]['um_rednibroj'],
              'brojmodula': res.data[i]['um_rednibrojmodula'],
              'redoslijedizvodenja': res.data[i]['um_redoslijedizvodenja'],
              'naziv': res.data[i]['mo_naziv'],
              'kratica': res.data[i]['um_kratica'],
              'datum': moment(res.data[i]['um_datum']).format('DD.MM.YYYY.'),
              'satiod': res.data[i]['satiodprikaz'],
              'satido': res.data[i]['satidoprikaz'],
              'idnacinpredavanja': res.data[i]['nacinpredavanja_idnacinpredavanja'],
              'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
              'aktivan': res.data[i]['um_aktivan']
            })
          }else{
            this.sviModuli.push({
              'idUcionicamodul': res.data[i]['iducionicamodul'],
              'id': res.data[i]['idmodul'],
              'rednibroj': res.data[i]['um_rednibroj'],
              'brojmodula': res.data[i]['um_rednibrojmodula'],
              'redoslijedizvodenja': res.data[i]['um_redoslijedizvodenja'],
              'naziv': res.data[i]['mo_naziv'],
              'kratica': res.data[i]['um_kratica'],
              'datum': null,
              'satiod': res.data[i]['satiodprikaz'],
              'satido': res.data[i]['satidoprikaz'],
              'idnacinpredavanja': res.data[i]['nacinpredavanja_idnacinpredavanja'],
              'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
              'aktivan': res.data[i]['um_aktivan']
            })
          }
        }
        this.nastavnejediniceTrigger.next();
      }else{
        toastr.error("Neuspješno dohvaćanje modula!");
      }
    });
  }

  /* Kopija dohvatiModule funkcije, ali uz timeout */
  osvjeziModule(){
    this.sviModuli = [];
    let _this1 = this;
    setTimeout(() => {
      _this1._ucionicaService.dohvatiModule({'iducionica': _this1.ucionicaId}).subscribe(res => {
        // console.log(res);
        if(res.success == true){
          for(let i = 0; i < res.data.length; i++){
            if(res.data[i]['um_datum']){
              _this1.sviModuli.push({
                'idUcionicamodul': res.data[i]['iducionicamodul'],
                'id': res.data[i]['idmodul'],
                'rednibroj': res.data[i]['um_rednibroj'],
                'brojmodula': res.data[i]['um_rednibrojmodula'],
                'redoslijedizvodenja': res.data[i]['um_redoslijedizvodenja'],
                'naziv': res.data[i]['mo_naziv'],
                'kratica': res.data[i]['um_kratica'],
                'datum': moment(res.data[i]['um_datum']).format('DD.MM.YYYY.'),
                'satiod': res.data[i]['satiodprikaz'],
                'satido': res.data[i]['satidoprikaz'],
                'idnacinpredavanja': res.data[i]['nacinpredavanja_idnacinpredavanja'],
                'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
                'aktivan': res.data[i]['um_aktivan']
              })
            }else{
              _this1.sviModuli.push({
                'idUcionicamodul': res.data[i]['iducionicamodul'],
                'id': res.data[i]['idmodul'],
                'rednibroj': res.data[i]['um_rednibroj'],
                'brojmodula': res.data[i]['um_rednibrojmodula'],
                'redoslijedizvodenja': res.data[i]['um_redoslijedizvodenja'],
                'naziv': res.data[i]['mo_naziv'],
                'kratica': res.data[i]['um_kratica'],
                'datum': null,
                'satiod': res.data[i]['satiodprikaz'],
                'satido': res.data[i]['satidoprikaz'],
                'idnacinpredavanja': res.data[i]['nacinpredavanja_idnacinpredavanja'],
                'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
                'aktivan': res.data[i]['um_aktivan']
              })
            }
          }
          _this1.nastavnejediniceTrigger.next();
        }else{
          toastr.error("Neuspješno dohvaćanje modula!");
        }
      });
    }, 600);
  }

  dohvatiAktivneModuleUcionica(){
    this.sviaktivnimoduli = [];
    this._ucionicaService.dohvatiAktivneModuleUcionica({'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviaktivnimoduli.push({
            'idUcionicamodul': res.data[i]['iducionicamodul'],
            'id': res.data[i]['idmodul'],
            'rednibroj': res.data[i]['um_rednibroj'],
            'naziv': res.data[i]['um_kratica'] + ' - ' + res.data[i]['mo_naziv'],
            'kratica': res.data[i]['um_kratica'],
            'idnacinpredavanja': res.data[i]['nacinpredavanja_idnacinpredavanja'],
            'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
            'aktivan': res.data[i]['mo_aktivan']
          });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  dohvatiAktivneModulePopis(){
    this.sviaktivnimodulipopis = [];
    this._ucionicaService.dohvatiAktivneModule({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviaktivnimodulipopis.push({
            'id': res.data[i]['idmodul'],
            'naziv': res.data[i]['mo_naziv'],
            'idnacinpredavanja': res.data[i]['idnacinpredavanja'], 
            'nacinpredavanja': res.data[i]['np_naziv'],
            'idpodrucjeznanja': res.data[i]['idpodrucjeznanja'],
            'podrucjeznanja': res.data[i]['pu_naziv'],
            'aktivan': res.data[i]['mo_aktivan']
          });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  dohvatiAktivneModuleNewPopis(){
    this.sviaktivnimodulinewpopis = [];
    this._ucionicaService.dohvatiAktivneModuleNew({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        this.sviaktivnimodulinewpopis = res.data;
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  ponisti(a){
    //console.log(a);
    if(a == 'modulnew'){
      this.modulForma.controls['modul'].reset('');
    }else if(a == 'modul'){
      this.modulForma.controls['modulnew'].reset('');
    }
  }

  dodajModul(modulForma){
    // console.log(modulForma);
    let objektZaSlanje = {
      'idmodulnew': modulForma['modulnew'],
      'idmodul': modulForma['modul'],
      'iducionica': this.ucionicaId
    };
    //console.log(objektZaSlanje);
    if(modulForma['modulnew'] || modulForma['modul']){
      this._ucionicaService.addModul_ucionica(objektZaSlanje).subscribe(res => {
        // console.log(res);
        if(res.success == true){
          toastr.success("Uspješno dodani moduli!");
          $('#nastavnejediniceTablica').DataTable().clear();
          $('#nastavnejediniceTablica').DataTable().destroy();
          // this.dohvatiModule();
          this.osvjeziModule();
          this.modulForma = this._fb.group({
            modulnew: [''],
            modul: ['']
          });
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  pripremiPodatkeModul(modul){
    //console.log(modul);
    this.iducionicamodul = modul['idUcionicamodul'];
    this.modulEditForma= this._fb.group({
      naziv: modul['naziv'],
      kratica: modul['kratica'],
      rednibroj: modul['rednibroj'],
      brojmodula: modul['brojmodula'],
      redoslijedizvodenja: modul['redoslijedizvodenja'],
      datum: modul['datum'],
      aktivan: modul['aktivan'],
      idnacinpredavanja: modul['idnacinpredavanja']
    })
    this.datum = modul['datum'];
    this.satiod = modul['satiod'];
    this.satido = modul['satido'];
  }

  urediModul(modul){
    //console.log(modul);
    let datum;
    if(modul.datum){
      datum = moment(modul.datum.jsdate).format('YYYY-MM-DD');
    } else {
      datum = null;
    }

    let satiOd;
    if(this.satiod){
      satiOd = moment(this.satiod).format('HH:mm');
    } else {
      satiOd = null;
    }

    let satiDo;
    if(this.satido){
      satiDo = moment(this.satido).format('HH:mm');
    } else {
      satiDo = null;
    }

    let podaciZaSlanje = {
      'iducionicamodul': this.iducionicamodul,
      'rednibroj': modul.rednibroj,
      'brojmodula': modul.brojmodula,
      'redoslijedizvodenja': modul.redoslijedizvodenja,
      'datum': datum,
      'satiod': satiOd,
      'satido': satiDo,
      'aktivan': parseInt(modul.aktivan),
      'idnacinpredavanja': modul.idnacinpredavanja,
      'access_token': localStorage.getItem('tokenSql')
    }
    //console.log(podaciZaSlanje);
    this._ucionicaService.urediModul_ucionica(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#nastavnejediniceTablica').DataTable().destroy();
        // this.dohvatiModule();
        this.osvjeziModule();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  obrisiModul(modul){
    //console.log(modul);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati modul?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.obrisiModul_ucionica({'iducionicamodul': modul.idUcionicamodul, 'iducionica': ovo.ucionicaId}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Modul uspješno obrisan!");
            $('#nastavnejediniceTablica').DataTable().destroy();
            // ovo.dohvatiModule();
            ovo.osvjeziModule();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja modula.');
    });
  }



  pripremiPodatkeDodaniModul(modul){
    // console.log(modul);
    this.idmodulnew = modul['idmodulnew'];
    this.dodani_modulEditForma= this._fb.group({
      naziv: modul['naziv'],
      rednibroj: modul['rednibrojmodula'],
      iducionicamodul: modul['iducionicamodul'],
      idnacinpredavanja: modul['idnacinpredavanja']
    });
  }

  urediRedniBrojModulUcionica(modul){
    // console.log(modul);
    let podaciZaSlanje = {
      'iducionica': this.ucionicaId,
      'idmodulnew': this.idmodulnew,
      'um_rednibrojmodula': modul.rednibroj,
      'idnacinpredavanja': modul.idnacinpredavanja,
      'iducionicamodul': modul.iducionicamodul
    }
    // console.log(podaciZaSlanje);
    this._ucionicaService.urediRbModulUcionica(podaciZaSlanje).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#moduliTablica').DataTable().destroy();
        this.dohvatiDodaneModuleUcionica();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  dohvatiDodaneModuleUcionica(){
    let tmpmodul;
    $('#moduliTablica').DataTable().destroy();
    this.sviModuliUcionica = [];
    this._ucionicaService.dohvatiDodaneModuleUcionica({'iducionica': this.ucionicaId}).subscribe(res=>{
      // console.log(res);
      if (res.success == true) {
        this.sviModuliUcionicaNastavnaJedinica = res.data;
        for(let i = 0; i < res.data.length; i++){
          if(tmpmodul != res.data[i]['modulnew_idmodulnew']){
              this.sviModuliUcionica.push({
                  'iducionicamodul': res.data[i]['iducionicamodul'],
                  'idmodulnew': res.data[i]['modulnew_idmodulnew'],
                  'naziv': res.data[i]['mn_nazivmodula'],
                  'rednibrojmodula': res.data[i]['um_rednibrojmodula'],
                  'nastavnajedinica': res.data[i]['nastavnajedinica'],
                  'idnacinpredavanja': res.data[i]['idnacinpredavanja']
              });
              tmpmodul = res.data[i]['modulnew_idmodulnew'];
          }
          // this.sviModuliUcionica.push({
          //   'iducionicamodul': res.data[i]['iducionicamodul'],
          //   'idmodulnew': res.data[i]['modulnew_idmodulnew'],
          //   'naziv': res.data[i]['mn_nazivmodula'],
          //   'rednibrojmodula': res.data[i]['um_rednibrojmodula'],
          //   'nastavnajedinica': res.data[i]['nastavnajedinica']        
          // });
        }
        // this.moduliTrigger.next();
        // $(document).ready(function(){
        //   var groupColumn = 1;
        //   var table = $('#moduliTablica').DataTable({
        //     "columnDefs": [
        //         { "visible": false, "targets": groupColumn }
        //     ],
        //     // "order": [[ groupColumn, 'asc' ]],
        //     "displayLength": 25,
        //     "drawCallback": function( settings ){
        //       var api = this.api();
        //       var rows = api.rows( {page:'current'} ).nodes();
        //       var last = null;
        //       api.column(groupColumn, {page:'current'} ).data().each( function ( group, i ){
        //         if( last !== group ){
        //           $(rows).eq( i ).before(
        //             '<tr class="group"><td colspan="3">'+group+'</td></tr>'
        //           );
        //           last = group;
        //         }
        //       });
        //     }
        //   });
        // });
      } else {
        toastr.error("Neuspješno dohvaćanje dodanih modula!");
      }
    });
  }



  //PRISUTNOST
  dohvatiPrisutnost(){
    //console.log(this.prisutnostForma);
    //console.log(this.prisutnostForma.value.modul);
    this.svaPrisutnost = [];
    this._ucionicaService.dohvatiPrisutnostUcionica({'idmodul': this.prisutnostForma.value.modul, 'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      if(res.success == true && res.data.length > 0){
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['um_datum']){
            this.svaPrisutnost.push({
              'id': res.data[i]['idkorisnikucionicamodul'],
              'imeiprezime': res.data[i]['ko_imeiprezime'],
              'naziv': res.data[i]['mo_naziv'],
              'kratica': res.data[i]['um_kratica'],
              'datum': moment(res.data[i]['um_datum']).format('DD.MM.YYYY.'),
              'prisutan': res.data[i]['kum_prisutan']
            })
          }else{
            this.svaPrisutnost.push({
              'id': res.data[i]['idkorisnikucionicamodul'],
              'imeiprezime': res.data[i]['ko_imeiprezime'],
              'naziv': res.data[i]['mo_naziv'],
              'kratica': res.data[i]['um_kratica'],
              'datum': null,
              'prisutan': res.data[i]['kum_prisutan']
            })
          }
        }
        this.prisutnostTrigger.next();
      }else{
        toastr.error("Neuspješno dohvaćanje prisutnosti!");
      }
    });
  }

  oznaciPrisutan(e, item){
    //console.log(e.target.checked);
    //console.log(item);
    let prisutan;
    if(e.target.checked == true){
      prisutan = 1;
    }else if(e.target.checked == false){
      prisutan = 0;
    }
    this._ucionicaService.urediPrisutnost_ucionica({'idkorisnikucionicamodul': item.id, 'prisutan': prisutan}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        $('#prisutnostTablica').DataTable().clear();
        $('#prisutnostTablica').DataTable().destroy();
        this.dohvatiPrisutnost();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  dohvatiPodatkeZaExcel(){
    this.podatcizaexcel = [];
    this._ucionicaService.dohvatiPodatkeExcel({'idmodul': this.prisutnostForma.value.modul, 'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      /*
      if(res.success == true){

        this.podatcizaexcel.push(
          {'': res.data[0].uc_naziv},
          {'': res.data[0].um_kratica},
          {'': moment(res.data[0]['um_datum']).format('DD.MM.YYYY.') || ''}
        );
        
        for(let i = 0; i < res.data.length; i++){
          this.podatcizaexcel.push({
            'Rb': i+1,
            'Ime i prezime': res.data[i]['ko_imeiprezime'],
            'Potpis': ''
          });
        }
        //console.log(this.podatcizaexcel);
      }else{

      }
      */
      if(res.success == true && res.data[0]){
        this.polaznicilistaPDF = res.data;

        let brojac = 1;
        this.tablicaprisutnostpolaznika = [];

        var kratica = res.data[0].um_kratica;
        var datum = moment(res.data[0]['um_datum']).format('DD.MM.YYYY.');

        this.tablicaprisutnostpolaznika.push([{ text: this.naziv, colSpan: 3, style: 'tableHeaderNaslov', fillColor: '#edeff2', bold: true, border: [false, true, false, false] }, 
                                              { text: '', fillColor: '#edeff2', border: [false, true, false, false] },
                                              { text: '', fillColor: '#edeff2', border: [false, true, false, false] }]);
        this.tablicaprisutnostpolaznika.push([{ text: kratica + ' PRISUTNOST', colSpan: 2, style: 'tableHeader1', fillColor: '#edeff2', border: [false, true, false, false] }, 
                                              { text: '', style: 'tableHeader1', fillColor: '#edeff2', border: [false, true, false, false] },
                                              { text: datum, style: 'tableHeader1', fillColor: '#edeff2', border: [false, true, false, false] }]);
        this.tablicaprisutnostpolaznika.push([{ text: '', fillColor: '#edeff2', border: [false, false, false, false] }, 
                                              { text: '', fillColor: '#edeff2', border: [false, false, false, false] },
                                              { text: '', fillColor: '#edeff2', border: [false, false, false, false] }]);
        this.tablicaprisutnostpolaznika.push([{ text: 'Rb.', fillColor: '#edeff2', border: [false, true, false, true] },
                                              { text: 'Ime i prezime', style: 'tableHeader2', fillColor: '#edeff2', border: [false, true, false, true] }, 
                                              { text: 'Potpis', style: 'tableHeader2', fillColor: '#edeff2', border: [false, true, false, true] }]);
        this.polaznicilistaPDF.forEach((item) => {
          this.tablicaprisutnostpolaznika.push([
            { text: brojac + '.', border: [false, false, false, false] },
            { text: item.ko_imeiprezime, border: [false, false, false, false] },
            { text: '', border: [false, false, false, true] }
          ]);
          brojac++;
        })
        this.tablicaprisutnostpolaznika.push([{ text: '', fillColor: '#edeff2', border: [false, true, false, false] },
                                              { text: '', fillColor: '#edeff2', border: [false, true, false, false] },
                                              { text: '', fillColor: '#edeff2', border: [false, true, false, false] }]);

        this.postaviZaIspis();
      }else{
        this.polaznicilistaPDF = [];
      }
    });
  }

  print() {
    pdfMake.createPdf(this.zaprint).open();
  }

  postaviZaIspis() {
    this.zaprint = {
      pageMargins: [40, 50, 40, 50],
      /* 
      footer: {
        columns: [
          {
            style: 'tablicafooter',
            table: {
  
  
              body: [
                [
                  { text: '...ovdje bude tekst koji je prikazan u footeru...', bold: true, fontSize: 8, alignment: 'center', border: [false, false, false, false] }
                ]
              ]
            },
          }
        ]
      }, 
      */
      content: [
        {
          style: 'tablicaopreme',
          table: {
            headerRows: 1,
            widths: [25, 150, 150],
            body:
              this.tablicaprisutnostpolaznika,
            },
        }
      ],
      styles: {
        tableHeaderNaslov: {
          fontSize: 14,
          margin: [0, 10, 0, 0],
          alignment: 'center'
        },
        tableHeader1: {
          margin: [0, 5, 0, 0]
        },
        tableHeader2: {
          alignment: 'center'
        },
        /* 
        tablicafooter: {
          alignment: 'center'
        }, 
        */
        checkBox: {
          fontSize: 30
        },
        /*
        podcrta: {
          margin: [-5, 0, 0, 0]
        }, 
        */
        tablicaopreme: {
          fontSize: 12,
          margin: [5, 10, 0, 0]
        }
      }
    }
  }

  exportAsXLSX():void{
    this._excelService.exportAsExcelFile(this.podatcizaexcel, 'prisutnost');
  }



  //GANTOGRAM
  dohvatiPodatkeGantogram(){
    this.podaciGantogram = [];
    this._ucionicaService.dohvatiPodatkeGantogram({'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        let prisutan;
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['um_datum']){
            if(res.data[i]['kum_prisutan'] == 1){
              prisutan = 'DA';
            }else{
              prisutan = null;
            }
            this.podaciGantogram.push({
              'id': res.data[i]['idkorisnikucionicamodul'],
              'imeiprezime': res.data[i]['ko_imeiprezime'],
              'modul': res.data[i]['um_kratica'],
              'modulgantogram': res.data[i]['kraticagantogram'],
              'prisutan': prisutan,
              'datum': moment(res.data[i]['um_datum']).format('DD.MM.YYYY.')
            })
          }else{
            if(res.data[i]['kum_prisutan'] == 1){
              prisutan = 'DA';
            }else{
              prisutan = null;
            }
            this.podaciGantogram.push({
              'id': res.data[i]['idkorisnikucionicamodul'],
              'imeiprezime': res.data[i]['ko_imeiprezime'],
              'modul': res.data[i]['um_kratica'],
              'modulgantogram': res.data[i]['kraticagantogram'],
              'prisutan': prisutan,
              'datum': null
            })
          }
        }  
        
        this.pivotGridDataSource = new PivotGridDataSource({
          fields: [{  
            caption: 'Modul',
            dataField: 'modulgantogram',
            dataType: 'string',
            expanded: true,
            area: 'column',
          },
          {
            caption: 'Datum', 
            dataField: 'datum',
            dataType: 'string',        
            area: 'column'
          },
          {
            caption: 'Ime i prezime',
            width: 150,
            dataField: 'imeiprezime',
            area: 'row'
          },
          {
            caption: 'Prisutan',
            dataField: 'prisutan',
            dataType: 'string',
            area: 'data'     
          },        
        ],
          store: this.podaciGantogram  
        });   

      }else{
        toastr.error("Neuspješno dohvaćanje!");
      }
    });

  }

  onCellPrepared(e) { 
    var dataFields = e.component.getDataSource().getAreaFields("data"),
    data = e.component.getDataSource().getData();
    this.broj = data.columns.length

     if(e.cell.columnType === "GT" ){           
        e.cellElement.textContent = ((e.cell.value/this.broj ) * 100).toFixed() + '%';
      }
    }
  
  citySelector(data) {
    //console.log(data);
    return data.city + ' (' + data.country + ')';
  }

  //KRITERIJI
  dohvatiKriterije(){
    this._ucionicaService.kriterijiPopis({'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        if(res.data.length != 0){
          this.postojiKriterijProlaznosti = true;
          this.kriterijiProlaznostiForma = this._fb.group({
            idkriterijtestiranjakompetencija: res.data[0].idkriterijtestiranjakompetencija,
            opis: res.data[0].ktk_opis
          });
        }
      } else {
        this.postojiKriterijProlaznosti = false;
        toastr.error("Neuspješno!");
      }
    });
  }

  spremiKriterijProlaznosti(podaci){
    this._ucionicaService.dodaj_kriterij_testiranja_kompetencija({'iducionica': this.ucionicaId, 'opis': podaci.opis}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        toastr.success("Uspješno!");
        this.dohvatiKriterije();
      } else {
        toastr.error("Neuspješno!");
      }
    });
  }

  urediKriterijProlaznosti(data){
    this.kriterijiProlaznostiForma = this._fb.group({
      idkriterijtestiranjakompetencija: data.idkriterijtestiranjakompetencija,
      opis: data.opis
    });
    // console.log(data);
    this._ucionicaService.uredi_kriterij_testiranja_kompetencija({'idkriterijtestiranjakompetencija': data.idkriterijtestiranjakompetencija, 'opis': data.opis}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        toastr.success("Uspješno!");
        // this.dohvatiKriterije();
      } else {
        toastr.error("Neuspješno!");
      }
    });
  }

  //Ishodi nastavke jedinice
  dohvatiIshodeNastavneJedinice(){
    this.dohvatiSvaPodrucjaznanja();
    this.odaberiIshod();
  }

  odaberiIshod(){
    // console.log(ishodiucenjaForma);
    // $('#ishodiNastavneJediniceTablica').DataTable().clear();
    $('#ishodiNastavneJediniceTablica').DataTable().destroy();
    this.dodajIshodGumb = true;
    this._ucionicaService.dohvati_sve_ishode_nastavnih_jedinica_za_ucionicu({'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        this.ishodiNastavneJedinice = [];
        if(res.data.length > 0){
          for(let i = 0; i < res.data.length; i++){
            if(res.data[i].idishodinastavnihjedinica != null){
              // console.log(res.data[i]);
              this.ishodiNastavneJedinice.push(res.data[i]);
            }
          }
          // this.ishodiNastavneJediniceTrigger.next();
          $(document).ready(function(){
            var groupColumn = 1;
            var table = $('#ishodiNastavneJediniceTablica').DataTable({
              "columnDefs": [
                  { "visible": false, "targets": groupColumn }
              ],
              // "order": [[ groupColumn, 'asc' ]],
              "displayLength": 25,
              "drawCallback": function( settings ){
                var api = this.api();
                var rows = api.rows( {page:'current'} ).nodes();
                var last = null;
      
                api.column(groupColumn, {page:'current'} ).data().each( function ( group, i ){
                  if( last !== group ){
                    $(rows).eq( i ).before(
                      '<tr class="group"><td colspan="4">'+group+'</td></tr>'
                    );
                    last = group;
                  }
                });
              }
            });
          });
        } else {
          toastr.error("Nema podataka!");
        }
      } else {
         toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  odaberiNastavnuJedinicu(ishodiucenjaForma){
    // console.log(ishodiucenjaForma);
    this.idNastavnaJedinica = ishodiucenjaForma.idNastavnaJedinica;
  }

  // ngAfterViewInit(): void {
  //   this.polaznikTrigger.next();
  //   this.videozapisTrigger.next();
  //   this.dokumentTrigger.next();
  //   this.predavacTrigger.next();
  //   this.emailTrigger.next();
  //   this.uvjerenjeTrigger.next();
  //   this.ishodiucenjaTrigger.next();
  //   this.nastavnejediniceTrigger.next();
  //   this.ishodiNastavneJediniceTrigger.next();
  //   this.moduliTrigger.next();
  //   this.prisutnostTrigger.next();
  // }

  ngOnDestroy(): void {
    this.polaznikTrigger.unsubscribe();
    this.videozapisTrigger.unsubscribe();
    this.dokumentTrigger.unsubscribe();
    this.predavacTrigger.unsubscribe();
    this.emailTrigger.unsubscribe();
    this.uvjerenjeTrigger.unsubscribe();
    this.ishodiucenjaTrigger.unsubscribe();
    this.nastavnejediniceTrigger.unsubscribe();
    this.ishodiNastavneJediniceTrigger.unsubscribe();
    this.moduliTrigger.unsubscribe();
    this.prisutnostTrigger.unsubscribe();
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ucionica-detalji/ucionica-detalji.component.ts